import { EventSubscriptionVendor } from './event-subscription';
import { Subscription } from './subscription';
import { ISubscription, ListenerProps } from './interface';

class EventEmitter<IEventToArgsMap> {
  _subscriber;

  constructor(subscriber = new EventSubscriptionVendor()) {
    this._subscriber = subscriber;
  }

  addListener(eventType: string, listener: (...args: IEventToArgsMap[]) => any) {
    return this._subscriber.addSubscription(
      eventType,
      new Subscription({
        eventType,
        listener,
        subscriber: this._subscriber,
      })
    );
  }

  removeAllListeners(eventType: string) {
    this._subscriber.removeAllSubscriptions(eventType);
  }

  removeSubscription(subscription: ISubscription) {
    this._subscriber.removeSubscription(subscription);
  }

  emit(eventType: string, ...args: IEventToArgsMap[]) {
    const subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    // 校验是否存在
    if (subscriptions) {
      for (let i = 0, l = subscriptions.length; i < l; i++) {
        const subscription = subscriptions[i];
        if (subscription && subscription.listener) {
          subscription.listener.apply(this, args); // react-native 此处传递了上下文 我们暂时还没有这个需求
        }
      }
    }
  }

  removeListener(eventType: string, listener: ListenerProps) {
    const subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    if (subscriptions) {
      for (let i = 0, l = subscriptions.length; i < l; i++) {
        const subscription = subscriptions[i];
        if (subscription && subscription.listener === listener) {
          this._subscriber.removeSubscription(subscription);
        }
      }
    }
  }
}

export default EventEmitter;
